<p-select [options]="actions" [(ngModel)]="selectedAction" optionLabel="name" optionValue="value" placeholder="Select"
  optionDisabled="disabled" (onChange)="handleChange($event)" [disabled]="disableField">
  <ng-template let-action pTemplate="item">
    <div class="action-item" [ngClass]="action.value">
      <div>{{action.name}}</div>
    </div>
  </ng-template>
</p-select>